// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cancel_watcher_creation-module__button--Qz4cJ{display:inline-block;margin-right:10px;-webkit-transition:all 0.25s ease;-o-transition:all 0.25s ease;-moz-transition:all 0.25s ease;transition:all 0.25s ease;height:40px;border-color:#5283d5;background-color:#5283d5;margin:0}.cancel_watcher_creation-module__icon--3rejI{padding-right:4px}\n", ""]);
// Exports
exports.locals = {
	"button": "cancel_watcher_creation-module__button--Qz4cJ",
	"icon": "cancel_watcher_creation-module__icon--3rejI"
};
module.exports = exports;
